export const APP_STORE_LINK = 'https://apps.apple.com/app/id1074208600';
export const GOOGLE_PLAY_LINK =
  'https://play.google.com/store/apps/details?id=com.indyzalab.transitia';
export const APP_GALLERY_LINK =
  'https://appgallery.cloud.huawei.com/ag/n/app/C101374155?channelId=web&detailType=0';
